/**
 * localStorage is web-only, so this module does not touch it.
 * The web app registers the implementation.
 */

let _clearPwLocalStorage = () => {};

export function setClearPwLocalStorage(func: () => void) {
  _clearPwLocalStorage = func;
}

export const clearPwLocalStorage = () => {
  try {
    _clearPwLocalStorage();
  } catch {
    // Browser storage can be blocked; legacy password cleanup must not interrupt app initialization.
  }
};
